import { Capacitor, registerPlugin } from "@capacitor/core";

const ShareIntent = registerPlugin("ShareIntent");

export const importRouteFor = (url) => `/app/ricette?import=${encodeURIComponent(url)}`;
export const importPhotosRoute = "/app/ricette?importPhotos=1";

// Shared cookbook photos are too large for the URL → held in memory until the
// recipe page picks them up.
let _pendingImages = null;
export const stashShareImages = (imgs) => { _pendingImages = Array.isArray(imgs) && imgs.length ? imgs.slice(0, 4) : null; };
export const takeShareImages = () => { const i = _pendingImages; _pendingImages = null; return i; };
// QA hook: lets browser automation simulate a native photo share.
if (typeof window !== "undefined") window.__solanoStashShareImages = stashShareImages;

// Returns { url, images } shared to the app while it was closed (or null).
export async function drainPendingShare() {
  if (!Capacitor.isNativePlatform()) return null;
  try {
    const { url, images } = await ShareIntent.getPending();
    if (!url && !(images && images.length)) return null;
    return { url: url || null, images: images && images.length ? images : null };
  } catch {
    return null;
  }
}

// Fires `fn({url, images})` whenever a share arrives while the app is running (Android).
export async function onShareReceived(fn) {
  if (!Capacitor.isNativePlatform()) return () => {};
  try {
    const h = await ShareIntent.addListener("shareReceived", (d) => { if (d?.url || d?.images?.length) fn(d); });
    return () => h?.remove?.();
  } catch {
    return () => {};
  }
}
